module.exports = __webpack_public_path__ + "static/img/p1.a16d02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/p1.png
// module id = RZpi
// module chunks = 1